import { DefaultToggle } from "../../forms/inputs/toggle/DefaultToggle";
import { FiltersPanelActions } from "../../filters/FiltersPanelActions";
import { FiltersPanelSection } from "../../filters/FiltersPanelSection";
import styles from "./ItemsListFiltersPanelContent.module.scss";

interface IItemsListFiltersPanelContentProps {
  showDeleted: boolean;
  sectionTitle?: string;
  toggleLabel?: string;
  onShowDeletedChange: (showDeleted: boolean) => void;
  onClearAllFilters: () => void;
  onClose: () => void;
}

export const ItemsListFiltersPanelContent = ({
  showDeleted,
  sectionTitle = "Изтрити записи",
  toggleLabel = "Покажи изтритите записи",
  onShowDeletedChange,
  onClearAllFilters,
  onClose,
}: IItemsListFiltersPanelContentProps) => {
  return (
    <div className={styles.root}>
      <FiltersPanelSection title={sectionTitle} icon={"🗑️"}>
        <DefaultToggle
          name="showDeletedItems"
          label={toggleLabel}
          standalone
          checked={showDeleted}
          maxWidth={"300px"}
          onChange={onShowDeletedChange}
        />
      </FiltersPanelSection>

      <FiltersPanelActions onApply={onClose} onClearAll={onClearAllFilters} />
    </div>
  );
};
